import getUrlForEnv, { services } from "@irati/utils/endpoints/getUrlForEnv";
var endpoints = {
    adyenCallbackUrl: function () { return getUrlForEnv(services.PAYMENTS_V2_SERVICE, "/orders/server-callback/adyen_classic"); },
    adyenRedirectCallbackUrl: function () { return getUrlForEnv(services.PAYMENTS_V2_SERVICE, "/orders/server-callback/adyen_classic/redirect"); },
    zipRedirectCallbackUrl: function () { return getUrlForEnv(services.PAYMENTS_V2_SERVICE, "/orders/server-callback/zip/redirect"); },
    paymentsBaseUrl: function () { return getUrlForEnv(services.PAYMENTS_V2_SERVICE, ""); }
};
export default endpoints;
